import type { ReactNode } from 'react';
import { ChevronDown, type LucideIcon } from 'lucide-react';

/**
 * A section that opens under its title. Native `<details>`, so the keyboard,
 * the find-in-page and the screen reader all know it already; the body wraps
 * long lines (a checksum, a command) instead of widening the card or the
 * dialog it sits in.
 */
export function Accordion({
  title,
  icon: Icon,
  open = false,
  children,
}: {
  readonly title: ReactNode;
  readonly icon?: LucideIcon;
  /** Open on first render. */
  readonly open?: boolean;
  readonly children: ReactNode;
}): ReactNode {
  return (
    <details className="accordion" open={open}>
      <summary className="accordion-head">
        {Icon ? <Icon size={16} aria-hidden="true" className="accordion-icon" /> : null}
        <span className="accordion-title">{title}</span>
        <ChevronDown size={16} aria-hidden="true" className="accordion-caret" />
      </summary>
      <div className="accordion-body">{children}</div>
    </details>
  );
}

/** Accordions one under another, drawn as one bordered list. */
export function AccordionGroup({ children }: { readonly children: ReactNode }): ReactNode {
  return <div className="accordion-group">{children}</div>;
}
